import React, { Component } from 'react'
import { Link } from 'react-router'

export default class PaneHeader extends Component {

  static propTypes = {

  }

  render() {
    return (
      <div className="headline horizontal fixed">
        <h1 className="with-tools stretch">Kennungen</h1>
        <div className="toolbar fixed">
          <span className="tools">
            <Link
              to="/user/create"
              title="Neue Kennung hinzufügen"
            >
              <svg
                className="tool-icon"
                width="18"
                height="18"
              >
                <use xlinkHref="#icon-plus-turquoise" />
              </svg>
            &nbsp;Hinzufügen
            </Link>
          </span>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/user/components/PaneHeader.js